export default "__VITE_ASSET__ebnzon6I__"